import { Component, inject } from '@angular/core';
import { SuperiorClasificationService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SuperiorClasificationCreateDto,
  SuperiorClasificationDto,
  SuperiorClasificationExcelDownloadDto,
  SuperiorClasificationUpdateDto,
} from '../proxy/planning/dtos/superior-clasification';
import { SUPERIORCLASIFICATION_CONFIG, SUPERIORCLASIFICATION_FIELDS } from './superior-clasification.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-superior-clasification',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SuperiorClasificationService, ConfirmationService],
  templateUrl: './superior-clasification.html',
  styleUrl: './superior-clasification.scss',
})
export class SuperiorClasification extends BaseCrudComponent<
  SuperiorClasificationDto,
  SuperiorClasificationCreateDto,
  SuperiorClasificationUpdateDto,
  SuperiorClasificationExcelDownloadDto
> {
  service = inject(SuperiorClasificationService);
  config = SUPERIORCLASIFICATION_CONFIG;
  fields = SUPERIORCLASIFICATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: SuperiorClasificationDto): SuperiorClasificationUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SuperiorClasification';
  }
}
